
















import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  data() {
    return {
      site: process.env.SITE,
    };
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'username']),
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push({ name: 'Login' });
    },
  },
});
